import React, { useEffect, useRef, useState } from "react";

import { useQuery } from "react-query";
import { getTopEventConsumersByRange } from "../actions";

import { Link } from "react-router-dom";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import Table from "./EventsTable";
import BarChart from "./BarChart";

import DetailedLineChart from "./DetailedLineChart";
import EventLogTable from "./EventLogTable";

const TopEventsByBandwidth = ({ clientID, startDate, endDate }) => {
  const { data, isError, refetch } = useQuery({
    queryKey: `topBWConsumers`,
    queryFn: () =>
      getTopEventConsumersByRange({ clientID, startDate, endDate }),
    placeholderData: [],
  });

  const [page, setPage] = useState(0);

  const [hoveredEventID, setHoveredEventID] = useState(null);
  const [selectedEventID, setSelectedEventID] = useState(null);

  const [singleEventDetails, setSingleEventDetails] = useState([]);

  const eventsToRender = data.slice(page * 5, page * 5 + 5);

  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    setSingleEventDetails([]);
    setSelectedEventID(null);
    setHoveredEventID(null);
    refetch();
  }, [startDate, endDate]);

  if (isError) return <div className="error">Error loading data</div>;

  return (
    <>
      <Box display="flex" justifyContent="space-between" sx={{ my: 1 }}>
        <Typography variant="h3" sx={{ ml: 0.12 }}>
          Top Events By Bandwidth
          {selectedEventID && (
            <>
              {" - "}
              <Link to={`/events/?eventID=${selectedEventID}`}>
                {selectedEventID}
              </Link>
            </>
          )}
        </Typography>
      </Box>

      <Grid container spacing={1}>
        <Grid item xs={12} md={6.3} lg={7}>
          {selectedEventID ? (
            <DetailedLineChart
              eventID={selectedEventID}
              clientID={clientID}
              startDate={startDate}
              endDate={endDate}
              setSingleEventDetails={setSingleEventDetails}
            />
          ) : (
            <BarChart
              setHoveredEventID={setHoveredEventID}
              eventsToRender={eventsToRender}
              setSelectedEventID={setSelectedEventID}
            />
          )}
        </Grid>

        <Grid item xs={12} md={5.7} lg={5}>
          {selectedEventID ? (
            <EventLogTable
              singleEventDetails={singleEventDetails}
              setSingleEventDetails={setSingleEventDetails}
              setSelectedEventID={setSelectedEventID}
            />
          ) : (
            <Table
              data={eventsToRender}
              count={data.length}
              page={page}
              setPage={setPage}
              hoveredEventID={hoveredEventID}
              setHoveredEventID={setHoveredEventID}
              selectedEventID={selectedEventID}
              setSelectedEventID={setSelectedEventID}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default TopEventsByBandwidth;
